@use "variables" as *;

.subtitle {
  text-align: center;
  font-weight: bold;
  font-size: $fontSize-m;
}

.message {
  text-align: center;
  font-weight: normal;
  font-size: $fontSize-s;
  white-space: pre-wrap;
}

.progressBar {
  padding: 100px;
  display: flex;
  position: relative;
  align-self: center;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.progressBarDiv {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.progressText {
  height: 100%;
  width: 100%;
  font-size: $fontSize-xxl;
  font-weight: bolder;
}

.cancelButton {
  width: 100%;
}
